import { useQuery } from 'react-query';
import hash from 'object-hash';
import { UserType } from '../types/types';

const baseRoute = process.env.REACT_APP_BASE_URL;

export interface MatriculasType {
  ano: number;
  mes: number;
  monto: number;
}

async function getMatriculasApiCall( user?: UserType | null) {
  if (!user?.token) return null;
  const headers = {
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/matriculas`,
    { headers, method: 'GET' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as MatriculasType[];
}

async function setMatriculasApiCall(params?:MatriculasType[] | null, user?: UserType | null) {
  if (!user?.token) return null;
  if (!params) return null;
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/matriculas`,
    { headers, body: JSON.stringify(params), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as boolean;
}

export function useGetMatriculas( user?: UserType | null) {
  return useQuery<MatriculasType[] | null, Error>(
    ['getMatriculas', hash(user ?? '')],
    () => getMatriculasApiCall(user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}

export function useSetMatriculas(params?: MatriculasType[] | null, user?: UserType | null) {
  return useQuery<boolean | null, Error>(
    ['setMatriculas', hash(params ?? ''), hash(user ?? '')],
    () => setMatriculasApiCall(params, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}
